






























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, CDR, StoreState,Timezone } from '../../store';
import { mapState } from 'vuex';
import Sidebar from "../../components/Sidebar.vue";
import * as moment from 'moment-timezone';
import momentTZ from 'moment-timezone';
import 'moment-duration-format';  
import VueElementLoading from 'vue-element-loading';
  import util from '../../lib/util';
  import VueExcelXlsx from "vue-excel-xlsx";

Vue.use(VueExcelXlsx);
 @Component({
  components: {
   Sidebar,
    VueElementLoading
  },
     computed: {
            ...mapState({
                'cdrs_callReportsHistory': (state: StoreState) => state.reports.callReportsHistory, 
                'callReports': (state: StoreState) => state.reports.callReports,
                'extensionsList': (state: StoreState) => state.reports.filters.extensionsList,//
                'timezone'  : (state: StoreState) => state.reports.filters.timezone,  
                'call_history': (state: StoreState) => (state.dashboard as any).call_history,  
                'cdrs': (state: StoreState) => state.reports.callReports,  
                'answeredNo': (state: StoreState) => state.reports.filters.answeredNo,                 
            })
        },
        mounted () {
            // debugger               
              this.$data.callloader = true;       
               this.$store.commit('SET_TIMEZONE', {
                timezone: this.$data.timezones[0]
            });
            //  this.$store.commit("CALLREPORT_SLIDER", true);
           
            //    this.$store.commit('ANSWERED_NO_CHANGE',  { newVal:true });
            //   this.$store.dispatch('getCallHistory', {bookmarks: JSON.stringify((this as any).call_history.bookmarks)}) 
            this.$store.dispatch('getUsers').then((r) => {
                this.getCallcustomreports(r.data.users.data);
            });
           
            
          
        
        }
  })

  export default class CallReportSp2 extends Vue {
    @Prop()
    public cdr!: CDR; 
      timezone!: Timezone;  
 data() {
 return {
     timezones: [
                    {
                        abbrev: 'ET',
                        tz: 'America/New_York'
                    },
     ],
     namearr:[],
     callloader:false,
     sortinstatus:true,
     sortoutstatus:true,
     sortcallstatus:true,
     sortmissedstatus:true,
     sortavgstatus:true,
     sorttotaldurstatus:true,
     sortextstatus:true,
     sortnamestatus:true,
     exceldata:[],
     val:'',
     startval : new Date(new Date(new Date(new Date().setMonth(new Date().getMonth() - 1))).toDateString()),
      maxdate:new Date(), 
      waterMark:"",
      formatdate:"",
      daterangeFormat: "MMM dd,yyyy", 
      endval : new Date().toDateString(),
     startDate:new Date(new Date(new Date(new Date().setMonth(new Date().getMonth() - 1))).toDateString()).getTime(),
     endDate:new Date().getTime(),      
     reportsval:[],  
     mainreportsval :[],
     start_date:'',
     end_date:'',
     search_call:'',
     name_filter_list:["fax", "mail room"],
     totalvalues:[],
        columns: [
          {
            label: "NAME",
            field: "name",
          },
          {
            label: "EXT",
            field: "ext",
          },
           {
            label: "INBOUND",
            field: "inbound",

          },
          {
            label: "OUTBOUND",
            field: "outbound",


          },
         
          {
            label: "TOTALCALLS",
            field: "totalcalls",
          },
          {
            label: "MISSEDCALLS",
            field: "missedcalls",
          },
          {
            label: "TOTALCALLDURATION",
            field: "totalcallduration",

          },
           {
            label: "AVGDURATION",
            field: "avgduration"
          },
        ]
       
 }
 }
 getCallcustomreports(kazoouserlist)
 {
  //  debugger      
            const  kazoouserlistids= kazoouserlist.map(u=>u.id);
            //alert(kazoouserlistids)
             this.$store.dispatch('getDailyreport', {para:{ shouldContinue: false,Page:-1},startDate:this.$data.startDate, endDate: this.$data.endDate,kazoouserlistids:kazoouserlistids}).then((r) => {
                 this.$data.reportsval=[];
                 var result=[]
                 r.data.reduce(function(res, value) {
                  if (!res[value.owner_id]) {
                       res[value.owner_id] = { owner_id: value.owner_id, outbound: 0 ,
                       inbound:0,total:0,missed_call:0,duration:0,
                       from_name:'',from_number:''};
                       result.push(res[value.owner_id])
                      }
                      const kazoouser= kazoouserlist.find(u=>u.id===value.owner_id)
                       res[value.owner_id].inbound += value.inbound;
                       res[value.owner_id].outbound += value.outbound;
                       res[value.owner_id].total += value.total;
                       res[value.owner_id].duration += value.duration;
                        res[value.owner_id].missed_call += value.missed_call;
                       res[value.owner_id].from_name =kazoouser?
                        `${kazoouser.first_name.trim()} ${kazoouser.last_name.trim()}`:value.from_name;
                        res[value.owner_id].from_number =kazoouser?kazoouser.presence_id:value.from_number;
                        

                    return res;
                  }, {});
console.log(result);
result = result.filter(r=>{
  return r.from_name && r.from_name != undefined
});
                const  name_filter_list= (this as any).name_filter_list;
               result=result.filter(r=> { 
                                              const filtered_a= name_filter_list.filter(e=> {
                                                          return r.from_name.toLowerCase().includes(e)
                                                        }
                                                        );
                                                       return filtered_a.length<=0})
               this.$data.reportsval     = result ;//r.data[0];
               this.$data.mainreportsval = result;
               if(this.$data.search_call) this.searchCallreports();
                 this.calculateTotal();
                 this.$data.callloader = false;  
             })

    }

  calculateaverage(r)
  {
        const avg= r.duration/r.total;
        return this.formaReportTime(avg)
         
  }
  calculateTotalAvg(arr)
  {
    let avg = 0;
    arr.forEach(element => {
      avg += (element.duration / element.total);
    });
    return this.formaReportTime(avg)
  }
        formaReportTime(value, addsuffix=true)
          {  
              const time=parseInt(value);
              var hour=Math.floor( time/3600);
              const minutes= Math.floor(time / 60) - (hour * 60);
              const sconds=(time % 60);
              const minutes_str=minutes.toString().padStart(1, '0');
              const sconds_str=sconds.toString().padStart(1, '0');
              const hour_str=hour.toString().padStart(1, '0');
              if (hour>0)
                  return `${hour}h ${minutes_str}m`;
              else if (minutes>0)
                  return `${minutes}m ${sconds_str}s`;
              else
                  return  `0m ${sconds_str}s`;
          }

       formatPhoneNumber(phoneNumber: any) {
        if(phoneNumber!=null){
          var phoneNumber=	phoneNumber.split("@");
            phoneNumber=phoneNumber[0];
        return util.formatPhoneNumber(phoneNumber);
              }
        }
    
   
       onDownloadcallreport()
       {
          this.$data.exceldata = [];
          for(let i=0;i<this.$data.reportsval.length;i++)
          {          
             var contobject = {
          name: this.$data.reportsval[i].from_name,
          ext: this.formatPhoneNumber(this.$data.reportsval[i].from_number),
          inbound:this.$data.reportsval[i].inbound,
          outbound:this.$data.reportsval[i].outbound,
          totalcalls:this.$data.reportsval[i].total ,
           missedcalls:this.$data.reportsval[i].missed_call,
            totalcallduration: this.formaReportTime(this.$data.reportsval[i].duration), //durationtotal
             avgduration:this.calculateaverage(this.$data.reportsval[i]) //this.formaReportTime(this.$data.reportsval[i].avgduration)
            
          }
           this.$data.exceldata.push(contobject);
          }
          
       }
       calreportdatechanged(args)
         {
          //  debugger
           this.$data.startDate = args.startDate;
          
         //  this.$data.startDate =  moment(this.$data.startDate).format('MM/DD/YYYY') ;
       this.$data.startDate=  (this.$data.startDate).getTime() ;       
           this.$data.endDate = args.endDate;
          //  this.$data.endDate =  moment(this.$data.endDate).format('MM/DD/YYYY') ;     
           this.$data.endDate=  ((this.$data.endDate).setHours((this.$data.endDate).getHours()+ 23,59,59)) 
           this.$data.callloader = true;              
            this.$store.dispatch('getUsers').then((r) => {
                this.getCallcustomreports(r.data.users.data);
            });         
         }

         searchCallreports() {        //selectedItems
            var selectedItems = this.$data.search_call.toLowerCase();
            var searcheditem = selectedItems;
      if (this.$data.search_call.length != 0) {

              var self = this;
              var selectedcompany = selectedItems;

              if (selectedcompany != '' || selectedcompany != undefined) {
          this.$data.reportsval =  this.$data.mainreportsval.filter(function (cust) {
                var name = cust.from_name.toString().toLowerCase();
                var ext = cust.from_number.toString();
                var inb = cust.inbound.toString();
                var outb = cust.outbound.toString();
                var total = (cust.inbound+ cust.outbound).toString() ;
                // var dur = (cust.duration);
                // dur.toString().toLowerCase();
                // var avgdur = cust.avgduration;
                // console.log(name)
                // console.log(searcheditem);
                // console.log(name.indexOf(searcheditem));
                  if (name.indexOf(searcheditem) >= 0 || ext.indexOf(searcheditem)>= 0 || inb.indexOf(searcheditem)>= 0 ||outb.indexOf(searcheditem)>= 0
                   || total.indexOf(searcheditem)>= 0) { //|| avgdur.indexOf(searcheditem)>= 0) {
                    return cust;
                  }
          })
              }
      }
          else{
                this.$data.reportsval = this.$data.mainreportsval;
          }
              
         }
         calculateTotal()
         {
          this.$data.totalvalues=  this.$data.reportsval.reduce(function(prev, cur) 
                {
                    if (!prev.totalinbound)
                    {
                      prev.totalinbound=0;
                      prev.totaloutbound=0;
                      prev.total_missed_call=0;
                      prev.totaldur=0;
                      prev.totalcal = 0;
                    }
                    prev.totalinbound+=cur.inbound;
                    prev.totaloutbound+=cur.outbound;
                    prev.totalcal+=cur.total;
                    prev.total_missed_call+=cur.missed_call;
                    prev.totaldur+=cur.duration;
                    return  prev;
                   
                  }, {});
                  // console.log(this.$data.totalvalues);
         }
         sortingcolumns(name)
         {        
          var sort_name = name;
          switch (sort_name) {
          case "name":      
           this.$data.sortnamestatus = !this.$data.sortnamestatus;             
           if (this.$data.sortnamestatus) {

          this.$data.mainreportsval.sort(function (a, b) {
            var nameA = a.from_name.toLowerCase(), nameB = b.from_name.toLowerCase()
            if (nameA < nameB) //sort string ascending
              return -1
            return 0
          })
        }
        else {
          this.$data.mainreportsval.sort(function (a, b) {
            var nameA = a.from_name.toLowerCase(), nameB = b.from_name.toLowerCase()
            if (nameA > nameB)
              return -1
            return 0
          })
        }             
          break;

          case "ext":
            this.$data.sortextstatus = !this.$data.sortextstatus;
        if (this.$data.sortextstatus) {
          this.$data.mainreportsval.sort(function (a, b) {
             var x = a.from_number==null?'' :  a.from_number;
             var y = b.from_number==null?'': b.from_number;
           return x-y;
          })
        }
        else {
          this.$data.mainreportsval.sort(function (a, b) {
            var x =a.from_number==null?'' :  a.from_number;
             var y = b.from_number==null?'': b.from_number;
           return y-x;
          })
        }
         break;

           case "inbound":
             this.$data.sortinstatus = !this.$data.sortinstatus;
        if (this.$data.sortinstatus) {
          this.$data.mainreportsval.sort(function (a, b) {
             var x = a.inbound==null?'' :  a.inbound;
             var y = b.inbound==null?'': b.inbound;
           return x-y;
          })
        }
        else {
          this.$data.mainreportsval.sort(function (a, b) {
            var x =a.inbound==null?'' :  a.inbound;
             var y = b.inbound==null?'': b.inbound;
           return y-x;
          })
        }
         break;
         case "outbound":
            this.$data.sortoutstatus = !this.$data.sortoutstatus;
        if (this.$data.sortoutstatus) {
          this.$data.mainreportsval.sort(function (a, b) {
             var x = a.outbound==null?'' :  a.outbound;
             var y = b.outbound==null?'': b.outbound;
           return x-y;
          })
        }
        else {
          this.$data.mainreportsval.sort(function (a, b) {
            var x =a.outbound==null?'' :  a.outbound;
             var y = b.outbound==null?'': b.outbound;
           return y-x;
          })
        }
         break;
          case "totalcall":
            this.$data.sortcallstatus =!this.$data.sortcallstatus;
        if (this.$data.sortcallstatus) {
          this.$data.mainreportsval.sort(function (a, b) {
             var x = a.total==null?'' :  a.total;
             var y = b.total==null?'': b.total;
           return x-y;
          })
        }
        else {
          this.$data.mainreportsval.sort(function (a, b) {
            var x =a.total==null?'' :  a.total;
             var y = b.total==null?'': b.total;
           return y-x;
          })
        }
         break;
          case "missed":
            this.$data.sortmissedstatus = !this.$data.sortmissedstatus;
        if (this.$data.sortmissedstatus) {
          this.$data.mainreportsval.sort(function (a, b) {
             var x = a.missed_call==null?'' :  a.missed_call;
             var y = b.missed_call==null?'': b.missed_call;
           return x-y;
          })
        }
        else {
          this.$data.mainreportsval.sort(function (a, b) {
            var x =a.missed_call==null?'' :  a.missed_call;
             var y = b.missed_call==null?'': b.missed_call;
           return y-x;
          })
        }
         break;
          case "totaldur":
            this.$data.sorttotaldurstatus = !this.$data.sorttotaldurstatus;
        if (this.$data.sorttotaldurstatus) {
          this.$data.mainreportsval.sort(function (a, b) {
             var x = a.duration==null?'' :  a.duration;
             var y = b.duration==null?'': b.duration;
           return x-y;
          })
        }
        else {
          this.$data.mainreportsval.sort(function (a, b) {
            var x =a.duration==null?'' :  a.duration;
             var y = b.duration==null?'': b.duration;
           return y-x;
          })
        }
         break;
          case "avg":
            this.$data.sortavgstatus = !this.$data.sortavgstatus;
        if (this.$data.sortavgstatus) {
          this.$data.mainreportsval.sort(function (a, b) {
             var x = (a.duration && a.total) ? (a.duration/a.total) : 0;
             var y = (b.duration && b.total) ? (b.duration/b.total) : 0;
           return x-y;
          })
        }
        else {
          this.$data.mainreportsval.sort(function (a, b) {
            var x = (a.duration && a.total) ? (a.duration/a.total) : 0;
             var y = (b.duration && b.total) ? (b.duration/b.total) : 0;
           return y-x;
          })
        }
         break;
      }
      }
      
         
   
       
       
 }
   
  
  